import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Image } from 'antd';
import type { ColumnType } from 'antd/es/table';

import { DragButton } from '@/shared/components';

import styles from './SchoolSpeakersSubsection.module.scss';
import type { ISpeakerItemData } from './types';

export const getColumnsData = ({
  openEditSpeakerModal,
  openDeleteSpeakerModal,
  setItemToOperate,
}: {
  openEditSpeakerModal: VoidFunction;
  openDeleteSpeakerModal: VoidFunction;
  setItemToOperate: (data: ISpeakerItemData | null) => void;
}) =>
  [
    {
      title: 'ФИО',
      dataIndex: 'full_name',
      key: 'full_name',
      ellipsis: true,
    },
    {
      title: 'Описание',
      dataIndex: 'bio',
      key: 'bio',
      ellipsis: true,
    },
    {
      title: 'Фото',
      dataIndex: ['photo', 'signed_id'],
      key: 'photo',
      width: 120,
      render: (_, { photo }) =>
        photo.url && (
          <Image
            className={styles['speaker-image']}
            width={34}
            height={34}
            src={photo.url}
            preview={{
              cover: <EyeOutlined />,
            }}
          />
        ),
    },
    {
      title: '',
      dataIndex: 'options',
      key: 'options',
      width: 216,
      render: (_, { id, full_name, bio, photo, job_title, position }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <DragButton rowKey={position} />
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, full_name, bio, photo, job_title, position });
              openEditSpeakerModal();
            }}
          >
            <EditOutlined style={{ fontSize: '20px' }} />
          </Button>
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, full_name, bio, photo, job_title, position });
              openDeleteSpeakerModal();
            }}
          >
            <DeleteOutlined style={{ fontSize: '20px' }} />
          </Button>
        </div>
      ),
      fixed: 'right',
    },
  ] as ColumnType<ISpeakerItemData>[];
